import React, { useEffect, useState } from 'react';
//REDUX
import {connect } from "react-redux";
import mapStateToProps from './mapStateToProps';
import mapDispatchToProps from './mapDispatchToProps';
//COMPONENTES
import DialogLoadingMessage from 'components/LoadingMessage/index'
import Form from 'components/Form/FormTwoColumns';
import {useStyles} from './style';
import { functions } from "constants/index";
import ApiServices from 'services/ApiServices';
import {Description} from '@material-ui/icons/';
import { IconButton, Grid } from '@material-ui/core';
import { showMessagePersonalizedPosition } from 'services/SweetAlert';
import Table from 'components/Table';
import { Alert } from '@material-ui/lab';
import ModalObservation from 'components/ModalObservation';

const  ComponenteDeFiltrosParaBusqueda= (props)=> {
    let catalogoOrigen = [
        {id: 1, name: 'SISTEMA'},
        {id: 2, name: 'RENAP'},
    ]
    const classes = useStyles(),
    [header] = useState([
        { title: 'Registro No.', field: 'iddetalle',cellStyle:{ maxWidth: '80px' } },
        { title: 'Nombre Fallecido', field: 'nombreCompleto', cellStyle:{ maxWidth: '100px' }},
        { title: 'Nombre Padre', field: 'nombrePadreCompleto', cellStyle:{ maxWidth: '100px' }},
        { title: 'Nombre Madre', field: 'nombreMadreCompleto', cellStyle:{ maxWidth: '100px' }},
        { title: 'CUI', field: 'cui' },
        { title: 'Cédula', field: 'cedula' },
        { title: 'Departamento Extensión', field: 'departamentoextensionn.nameShort' },
        { title: 'Municipio Extensión', field: 'municipioextensionn.municipio' },
        { title: 'Número boleta', field: 'nroboleta' },
        { title: 'Departamento Nacimiento', field: 'departamentonacimineto.nameShort' },
        { title: 'Municipio Nacimiento', field: 'municipionacimienton.municipio' },
        { title: 'Fecha Nacimiento', field: 'fechaNacimientoformato' },
        { title: 'Departamento defunción', field: 'datosfolio.departamentov.nameShort' },
        { title: 'Municipio defunción', field: 'datosfolio.municipiov.municipio',
            render: rowData=><div>
                {
                    (rowData.datosfolio.auxiliatura === null) ?
                    (rowData.datosfolio.municipiov.municipio) :
                    (rowData.datosfolio.auxiliatura.municipio.municipio)
                }
            </div>
        },
        { title: 'Auxiliatura', field: 'datosfolio.auxiliatura.name', },
        { title: 'Fecha Defunción', field: 'fechaDefuncionformato' },
        { title: 'Usuario', field: 'usuarioDigita', },
        { title: 'Fecha de creación', field: 'fechaCreacionString', },
        { title: 'Hora de creación', field: 'horaCreacionString', },
        { title: 'Origen', field: 'datosfolio.datosorigen', },
        { title: 'Datos folio', field: '', 
            render: (rowData) => (
                <div>
                    {(rowData.datosfolio) ? (
                        <IconButton  size="small" color="primary"
                            onClick={() => {
                                let observacion = []
                                observacion.push({title: 'Origen: ', text: rowData.datosfolio.datosorigen})
                                observacion.push({title: 'Folio: ', text: rowData.datosfolio.idfolio})
                                observacion.push({title: 'Departamento: ', text: rowData.datosfolio.departamentov.nameShort})
                                observacion.push({title: 'Municipio: ', text: (
                                    (rowData.datosfolio.auxiliatura === null) ?
                                    (rowData.datosfolio.municipiov.municipio) :
                                    (rowData.datosfolio.auxiliatura.municipio.municipio)                                            
                                )})
                                observacion.push({title: 'Auxiliatura: ', text: (rowData.datosfolio?.auxiliatura?.name) ? (rowData.datosfolio?.auxiliatura?.name):('')})
                                observacion.push({title: 'Año: ', text: rowData.datosfolio.año})
                                observacion.push({title: 'Fecha Inicio: ', text: functions.dateFormatGeneral(rowData.datosfolio.fechainicio)})
                                observacion.push({title: 'Fecha Final: ', text: functions.dateFormatGeneral(rowData.datosfolio.fechafinal)})
                                abrirObservacion();
                                setDatosObservacion({textoObservacion: observacion, title:'Datos del Folio'})
                            }}
                        >
                            <img alt="comments" style={{ height: 40, width: 40 }} src="/assets/comments.svg" />
                        </IconButton>
                    ) : ""}
                </div>
        )},                                        
    ]),
    [data, setData] = useState([]),
    [checkAutorization, setCheckAutorization] = useState(false),
    [openObservacion, setOpenObservacion] = useState(false),
    [datosObservacion, setDatosObservacion] = useState({textoObservacion: '', title:''}),
    [loadingStateCity, setLoadingStateCity] = useState({loading:false, title:''}),
    [elements,setElements] = React.useState({
        titleFolio:{
            idelement: "titleFolio",title:'Búsqueda por número de folio', position:"center", value: "", isError:true, elementType:'title', validators: ['requireds'],
        },            
            folio: {
                idelement: "folio",  value:'', label: "Ingrese No. Folio *", pattern:"^[\\w1-9_Ññ-]{1,11}$",
                validators: ['required'], errorMessages:['Ingrese No. Folio, sin espacios al inicio y final'], isError:false, elementType:'input', showInputControl: true,
            },
            año: {
                idelement: "año",  value:'', label: "Año de folio *", pattern:"^[0-9]{4,4}$",
                validators: ['required'], errorMessages:['Ingrese Año de Folio, sin espacios al inicio y final'], isError:false, elementType:'input', showInputControl: true,
            },
            origen: { 
                idelement: "origen", value:null , label: "Seleccione origen *", pattern:"^[1-9][0-9]*$", validators: ['required'], 
                errorMessages:['Seleccione origen'], isError:false, elementType:'autocompleteV2', list: catalogoOrigen, 
            },            
    });

    const RealizarConsultaPorFolioyAño = async () => {
        setCheckAutorization(false);
        setLoadingStateCity({loading: true, title:'Realizando consulta ...'})
        let saveData = {
            folio: elements.folio.value.toString(),
            año: elements.año.value.toString(),
            origen: elements.origen.value?.id
        };
        try {
            let response = await ApiServices.captacionFallecidos.obtenerFolio(saveData)
            if(response.error!==null){
                setCheckAutorization(false);
                showMessagePersonalizedPosition('error','Oopss!', response.error.message,'center')
            }
            else{
                showMessagePersonalizedPosition('success','¡BIEN!', 'Folio encontrado','center')
                setData(response.data)
                setCheckAutorization(true);
            }
        } catch (exception) {
            if (exception.status===404) {
                showMessagePersonalizedPosition('error', '¡Oops! ',"Falla del Sistema. Ponganse en contacto con el Administrador sí este mensaje persiste.",'center')
            }
            else {
                showMessagePersonalizedPosition('error', '¡Oops! ',"Intente de nuevo. Ponganse en contacto con el Administrador sí este mensaje persiste.",'center')
            }
        }  
        setLoadingStateCity({loading: false, title:''})
    };

    const [buttonList,setButtonList]= React.useState({
        "constancia":{"label":"BUSCAR REGISTROS","icon": <Description />,"callback":RealizarConsultaPorFolioyAño,"loading":loadingStateCity.loading, disabled:loadingStateCity.loading, "size":"medium", "background":"linear-gradient(45deg, #2196F3 30%, #21CBF3 90%)", "border":"0px", "borderRadius":"3", "boxShadow":"0 3px 5px 2px rgba(33, 203, 243, .3)", "color":"white", "height":37, padding:"0 30px",},   
    });

    const abrirObservacion = () => {
        setOpenObservacion(true)
    }
    const cerrarObservacion = () => {
        setOpenObservacion(false)
    }            
    useEffect(() => {
        elements.folio.value =''
        elements.año.value =''
        setData([])
        setCheckAutorization(false)
    },[props.open])
    return (
        <div style={{margin:' 0px 20px'}}>
            <ModalObservation open={openObservacion}  handleClose={cerrarObservacion} textoObservacion={datosObservacion.textoObservacion} title={datosObservacion.title} />
            <DialogLoadingMessage open={loadingStateCity.loading} title={loadingStateCity.title}/>
            <br/>
            {/* <Container maxWidth="lg">         */}
                <Grid container style={{textAlign: 'center'}}>
                    <div className={classes.colorComponente}>
                        <Grid item xs={12} direction="row" justify="center" alignItems="center">
                            <Form   elements= {elements} buttonList={buttonList}/>
                        </Grid>
                        {
                            (checkAutorization ) ?  (
                                <Grid className={classes.AlignTable} item xs={12}>
                                    <Table
                                        // service={ApiServices[controller]}
                                        title={"Registros"}
                                        data={data}
                                        header={header}
                                        showFilter={false}
                                        showFilterGeneral={false}
                                        pageSize={5}
                                    />
                                </Grid>
                            ): 
                            (    
                                <Grid className={classes.AlignAlerta} item xs={12} >
                                    <Alert  variant="outlined" severity="warning">Si desea buscar registros de un folio, ingrese el número de folio y año, de clic en el botón "BUSCAR"</Alert>
                                </Grid>
                            )
                        }

                        <div className={classes.lineaDegradadaBottom}></div>
                    </div>
                </Grid>
            {/* </Container> */}
        </div>
    );   
}


export default connect(mapStateToProps, mapDispatchToProps)(ComponenteDeFiltrosParaBusqueda);



